// frontend/src/components/common/SimpleClock.js
import { useEffect, useState } from 'react';

export default function SimpleClock() {
  const [time, setTime] = useState(() => new Date());

  useEffect(() => {
    const timeId = setInterval(() => setTime(new Date()), 100);
    return () => {
      clearInterval(timeId);
    };
  });

  return (
    <div className="text-[2rem]">
      <p>
        {time.toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false,
        })}
      </p>
    </div>
  );
}
